export const SCROLL_DISTANCE = 200;
export const BUTTON_OFFSET_WIDTH = 92;
export const SCROLL_DEBOUNCE_DELAY = 300;
export const RESIZE_THROTTLE_DELAY = 200;
